import { stockApi } from '$api'
import { Brand, IBrand } from '$models'
import { getActiveCompanySettings, singletonQueryClient } from '$utils'

enum QueryKeys {
  GetAllBrands = 'getAllBrands',
}

/**
 * Retrieves all brands
 * @returns an list of brands
 */
export const getAllBrands = async (): Promise<IBrand[]> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) return []

  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.GetAllBrands],
    queryFn: async () => {
      return await stockApi.getBrands()
    },
  })
}

/**
 * Creates a new brand
 * @param newBrand the new brand to be created
 * @returns the created brand
 */
export const createBrand = async (newBrand: IBrand): Promise<IBrand> => {
  const { hasStockPermission } = getActiveCompanySettings()

  if (!hasStockPermission) {
    throw new Error("The user doesn't have permission to create a new brand.")
  }

  return await stockApi.createBrand(new Brand(newBrand))
}
